import { jsx as r } from "react/jsx-runtime";
import { makeClassesByStyles as t } from "../../../../utils/classes.js";
import c from "../../../../assets/4d3d960c.icon.module.css";
const e = t(c), l = ({ className: s = "", name: o = "" }) => /* @__PURE__ */ r(
  "span",
  {
    "aria-label": `${o} icon`,
    className: e("Icon", `icon-${o}`, s),
    role: "img"
  }
);
export {
  l as Icon
};
